import {
  useMutation,
  useQueries,
  useQuery,
  useQueryClient
} from "@tanstack/react-query";
import {
  fetchInventoryConfigCreate,
  fetchInventoryConfigGet,
  fetchInventoryConfigUpdate,
  fetchInventoryConfigsGet
} from "./fetch";
import type {
  InventoryConfigUpdate,
  InventoryConfigUpdateMany
} from "./interface";
import type { InventoryListingConfig } from "@dealer-center/ddc-pages-inventory-config-interface";

const queryKeyBase = "ddc-pages-inventory-config";

export function useInventoryConfigGet({
  accountId,
  inventoryId
}: InventoryConfigUpdate) {
  return useQuery({
    queryKey: [queryKeyBase, { accountId, inventoryId }],
    enabled: !!accountId && !!inventoryId,
    queryFn: fetchInventoryConfigGet
  });
}
export function useInventoryConfigGetMany({
  accountId,
  inventoryIds
}: InventoryConfigUpdateMany) {
  return useQueries({
    queries: inventoryIds.map(inventoryId => ({
      queryKey: [queryKeyBase, { accountId, inventoryId }],
      enabled: !!accountId && !!inventoryId,
      queryFn: () =>
        fetchInventoryConfigGet({
          queryKey: [queryKeyBase, { accountId: accountId || "", inventoryId }]
        })
    }))
  });
}

export function useInventoryConfigsGet(accountId?: string | null) {
  return useQuery({
    queryKey: [queryKeyBase, accountId],
    enabled: !!accountId,
    queryFn: () =>
      fetchInventoryConfigsGet([queryKeyBase, accountId || ""], accountId || "")
  });
}

export function useInventoryConfigCreate() {
  const queryClient = useQueryClient();
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeyBase] });
    },
    mutationFn: (config: InventoryListingConfig) => {
      return fetchInventoryConfigCreate(config);
    }
  });
}

export function useInventoryConfigUpdate() {
  const queryClient = useQueryClient();
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeyBase] });
    },
    mutationFn: (config: InventoryListingConfig) => {
      return fetchInventoryConfigUpdate(config);
    }
  });
}
